import GlobalState from "src/shared/utilities/globalState";

const handleLoginFlow = () => ({
  triggerScenario: idToSave => {
    const triggerScenario = GlobalState.get("triggerScenario");
    if (typeof triggerScenario === "function") {
      GlobalState.get("callbacks").accountCreated = undefined;
      GlobalState.get("callbacks").login = undefined;

      GlobalState.registerCallback("accountCreated", () =>
        window.location.reload()
      );
      GlobalState.registerCallback("login", () => window.location.reload());

      GlobalState.get("triggerScenario")("EmailCapture", {
        after_login: { oh_to_register: idToSave }
      });
    }
  },
  registerOHAfterReload: register => {
    if (GlobalState.get("oh_to_register")) {
      register(GlobalState.get("oh_to_register"));
      GlobalState.set("oh_to_register", undefined);
    }
  }
});

export default handleLoginFlow;
